/** Traductions modal écarts caisse (FR / AR) */
export const ecartModalFr = {
  typeSelf: 'Écart Personnel',
  typeHandover: 'Écart de Remise',
  typeDefault: 'Écart',
  statusAccepted: 'Accepté',
  statusRejected: 'Rejeté',
  statusPending: 'En attente',
  statusUnknown: 'Non spécifié',
  noDescription: 'Aucune description',
  reportTitle: 'Rapport des Écarts',
  totalAmount: 'Montant Total',
  positive: 'Positif',
  negative: 'Négatif',
  net: 'Net',
  totalDeviations: 'Total Écarts',
  title: 'Aperçu des Écarts avec Détails Complets',
  totalAmountLabel: 'Montant total',
  colType: 'Type',
  colWorker: 'Employé',
  colDate: 'Date',
  colAmount: 'Montant',
  colDescription: 'Description',
  colStatus: 'Statut',
  colActions: 'Actions',
  view: 'Voir',
  accept: 'Accepter',
  reject: 'Rejeter',
  comment: 'Commenter',
  cancel: 'Annuler',
  ecartSummary: 'Résumé des Écarts',
  ecartUnit: 'écart(s)',
  totalLabel: 'Total',
  totalMeta: 'total',
  detailsTitle: 'Détails de l\'écart',
  labelType: 'Type:',
  labelWorker: 'Employé:',
  labelDate: 'Date:',
  labelTotalDiff: 'Différence totale:',
  labelBreakdown: 'Détail de l\'écart:',
  cashDiff: 'Différence espèces',
  electronicDiff: 'Différence électronique',
  labelSessionBreakdown: 'Détail session:',
  cashOpening: 'Début espèces',
  electronicOpening: 'Début électronique',
  cashSales: 'Ventes espèces',
  electronicSales: 'Ventes électroniques',
  labelDescription: 'Description:',
  labelStatus: 'Statut:',
  close: 'Fermer',
  addComment: 'Ajouter un commentaire',
  managerComment: 'Commentaire du manager:',
  commentPlaceholder: 'Entrez votre commentaire ici...',
  acceptWithComment: 'Accepter avec commentaire',
  rejectWithComment: 'Rejeter avec commentaire',
  noEcarts: 'Aucun écart enregistré',
  noOpenEcarts: 'Aucun écart ouvert — tous les écarts sont traités ou aucune session n\'a généré d\'écart.',
  closeAria: 'Fermer',
  unknownWorker: 'Non spécifié',
  loadingSessions: 'Chargement des sessions…',
  decisionFailed: 'Impossible d\'enregistrer la décision. Réessayez.',
  exportColType: 'Type',
  exportColWorker: 'Employé',
  exportColDate: 'Date',
  exportColAmount: 'Montant',
  exportColDescription: 'Description',
  exportColStatus: 'Statut'
};

export const ecartModalAr = {
  typeSelf: 'فرق صندوق شخصي',
  typeHandover: 'فرق صندوق تسليم',
  typeDefault: 'فرق صندوق',
  statusAccepted: 'مقبول',
  statusRejected: 'مرفوض',
  statusPending: 'معلق',
  statusUnknown: 'غير محدد',
  noDescription: 'لا يوجد وصف',
  reportTitle: 'تقرير فروق الصندوق',
  totalAmount: 'المبلغ الإجمالي',
  positive: 'إيجابي',
  negative: 'سلبي',
  net: 'صافي',
  totalDeviations: 'إجمالي فروق الصندوق',
  title: 'نظرة عامة على فروق الصندوق',
  totalAmountLabel: 'المبلغ الإجمالي',
  colType: 'النوع',
  colWorker: 'العامل',
  colDate: 'التاريخ',
  colAmount: 'المبلغ',
  colDescription: 'الوصف',
  colStatus: 'الحالة',
  colActions: 'الإجراءات',
  view: 'عرض',
  accept: 'قبول',
  reject: 'رفض',
  comment: 'تعليق',
  cancel: 'إلغاء',
  ecartSummary: 'ملخص فروق الصندوق',
  ecartUnit: 'فرق',
  totalLabel: 'المجموع',
  totalMeta: 'إجمالي',
  detailsTitle: 'تفاصيل فرق الصندوق',
  labelType: 'النوع:',
  labelWorker: 'العامل:',
  labelDate: 'التاريخ:',
  labelTotalDiff: 'الفرق الإجمالي:',
  labelBreakdown: 'تفصيل فرق الصندوق:',
  cashDiff: 'فرق النقد',
  electronicDiff: 'فرق الإلكتروني',
  labelSessionBreakdown: 'تفصيل الجلسة:',
  cashOpening: 'بداية النقد',
  electronicOpening: 'بداية الإلكتروني',
  cashSales: 'المبيعات النقدية',
  electronicSales: 'المبيعات الإلكترونية',
  labelDescription: 'الوصف:',
  labelStatus: 'الحالة:',
  close: 'إغلاق',
  addComment: 'إضافة تعليق',
  managerComment: 'تعليق المدير:',
  commentPlaceholder: 'أدخل تعليقك هنا...',
  acceptWithComment: 'قبول مع تعليق',
  rejectWithComment: 'رفض مع تعليق',
  noEcarts: 'لا توجد فروق صندوق مسجلة',
  noOpenEcarts: 'لا توجد فروق صندوق مفتوحة — تمت معالجة الكل أو لم تُنشأ فروق من الجلسات.',
  closeAria: 'إغلاق',
  unknownWorker: 'غير محدد',
  loadingSessions: 'جاري تحميل الجلسات…',
  decisionFailed: 'تعذر حفظ القرار. حاول مرة أخرى.',
  exportColType: 'النوع',
  exportColWorker: 'العامل',
  exportColDate: 'التاريخ',
  exportColAmount: 'المبلغ',
  exportColDescription: 'الوصف',
  exportColStatus: 'الحالة'
};
